import {
    Grid,
    GridProps,
} from '@chakra-ui/react';
import { CateringEventFormatModel } from 'entities';
import React from 'react';
import { GridCard } from 'shared';

export type CateringPageMainTabsCateringEventFormatsContentProps = {
    cateringEventFormats: CateringEventFormatModel[],
} & GridProps & React.RefAttributes<HTMLDivElement>

export const CateringPageMainTabsCateringEventFormatsContent
: React.FC<CateringPageMainTabsCateringEventFormatsContentProps> = ({
    cateringEventFormats,
}) => (
    <Grid
        gap="2rem"
        templateColumns={{
            base: '1fr 1fr',
            lg: '1fr 1fr 1fr 1fr',
        }}
    >
        {cateringEventFormats.map(({ slug, name, image }) => (
            <GridCard
                flex="1 0 21%"
                aspectRatio="2 / 3"
                label={name}
                to={`/catering/event-format/${slug}`}
                src={image?.url}
            />
        ))}
    </Grid>
);
